import { CulturalIdentityResponseDTO } from '../dtos/response/culturalIdentity'
import { CulturalIdentity } from '../entities/culturalIdentity'

export class CulturalIdentityMapper {
	static toEntity(data: CulturalIdentityResponseDTO): CulturalIdentity {
		return CulturalIdentity.create({
			id: data.id,
			name: data.name,
			key: data.key,
			sortOrder: data.sort_order,
			createdAt: data.created_at,
			updatedAt: data.updated_at,
		})
	}

	static toEntities(data: CulturalIdentityResponseDTO[]): CulturalIdentity[] {
		return data.map((item) => this.toEntity(item))
	}
}
